import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function RecoRow({ title, storeId, productId, exclude, store }) {
  const { data } = useQuery({
    queryKey: ["reco", storeId, productId, exclude],
    queryFn: () => api.get("/recommendations", { params: { store_id: storeId, product_id: productId, exclude, limit: 8 } }).then((r) => r.data),
    enabled: !!(storeId || productId),
  });
  if (!data || !data.length) return null;
  return (
    <section className="mt-8" data-testid="reco-row">
      <h3 className="mb-3 font-head text-lg font-bold text-slate-900">{title}</h3>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {data.map((p) => <ProductCard key={p.id} product={p} store={store || { id: p.store_id }} />)}
      </div>
    </section>
  );
}
